export let Code = {
type: `@Component({
    selector: 'p-dropdown',
    template:
        <p-dropdown [options]="cities" [(ngModel)]="selectedCity" placeholder="Select a City" optionLabel="name" [showClear]="true"></p-dropdown>
	<p>Selected City: {{selectedCity ? selectedCity.name : 'none'}}</p>
})
export class DropDown {

}
`,
typeEdit: `@Component({
    selector: 'p-dropdown',
    template:
        <p-dropdown [options]="cars" [(ngModel)]="selectedCar1" [style]="{'width':'150px'}" editable="true" placeholder="Select a Brand"></p-dropdown>
	<p style="margin-top: 10px;">Selected Car: {{selectedCar1 || 'none'}}</p>
})
export class DropDown {

}
`,
typeFilter: `@Component({
    selector: 'p-dropdown',
    template:
        <p-dropdown [options]="cars" [(ngModel)]="selectedCar2" [style]="{'width':'150px'}" filter="true">
		    <ng-template let-item pTemplate="selectedItem">
		        <img src="assets/showcase/images/demo/car/{{item.label}}.png" style="width:16px;vertical-align:middle" />
		        <span style="vertical-align:middle">{{item.label}}</span>
		    </ng-template>
		    <ng-template let-car pTemplate="item">
		        <div class="ui-helper-clearfix" style="position: relative;height: 25px;">
		            <img src="assets/showcase/images/demo/car/{{car.label}}.png" style="width:24px;position:absolute;top:1px;left:5px"/>
		            <div style="font-size:14px;float:right;margin-top:4px">{{car.label}}</div>
		        </div>
		    </ng-template>
		</p-dropdown>
	<p>Selected Car: {{selectedCar2||'none'}}</p>
})
export class DropDown {

}
`,
typeGroup: `@Component({
    selector: 'p-dropdown',
    template:
       <p-dropdown [options]="groupedCars" [(ngModel)]="selectedCar3" [style]="{'width':'150px'}" placeholder="Select a Car" [group]="true">
			<ng-template let-group pTemplate="group">
		        <img src="assets/showcase/images/demo/flag/{{group.value}}" style="width:20px;vertical-align:middle" />
		        <span style="vertical-align:middle">{{group.label}}</span>
		    </ng-template>
		</p-dropdown>
})
export class DropDown {

}
`,

};


// WEBPACK FOOTER //
// ./src/app/code/dropDown.ts